module.exports = __webpack_public_path__ + "assets/img/a118a69427356840e72d283b51ddae7d.png";